<template>
	<section class="lg:flex lg:items-center lg:flex-row-reverse">
		<div class="flex flex-col lg:w-1/2 lg:px-3 xl:px-10">
			<h3 class="text-center text-xl font-semibold sm:text-3xl md:text-4xl lg:text-left lg:leading-tight">Not Sure Which Antenna Is Best For You?</h3>
			<p class="px-4 mt-3 text-center text-lg sm:text-left sm:px-6 sm:text-2xl lg:mt-2 lg:px-0 lg:leading-tight xl:text-3xl">Why not take a look at our DISH Outdoors guides? It is designed to help anyone find the right solution for their outdoor entertainment experience!</p>
			<a href="" class="mt-6 text-white bg-dish-red py-2 px-4 rounded font-semibold mx-auto sm:px-6 sm:text-lg lg:text-xl lg:mt-3 xl:text-2xl xl:mt-5">Get Our Guide</a>
		</div>
		<div class="mt-2 lg:mt-0 lg:w-1/2">
			<img :src="require('@/assets/image/Referral-Antennas.png')">
		</div>
	</section>
</template>
